import React from 'react'
import { Card, Col, Row } from 'react-bootstrap'
import offpam from '../Images/Offerpampers.jpg'
import offadul from '../Images/offeradultdiaper.jpg'
import offolive from '../Images/offreolive.jpg'
import offdogbed from '../Images/offerdogbed.jpg'
import offmosq from '../Images/offermosqbat.jpg'
import offmam from '../Images/offermamypoko.jpg'
import disc1 from '../Images/disc1.jpg'
import disc2 from '../Images/disc2.jpg'
import disc3 from '../Images/disc3.jpg'
import disc4 from '../Images/disc4.jpg'
import disc5 from '../Images/disc5.jpeg'
import disc6 from '../Images/disc6.jpg'
import '../Cardpage.css'
function Dicounts() {
  return (
    <div >
        <h2 className='ms-3 mt-5' style={{fontFamily:'times new roman'}}>Lightning Deals</h2>
        <div className='cards'>
        <div>
            <Card className='ms-1'>
                    <Card.Img className=' disccardimg' src={offpam} alt="" />
                    <Card.Body style={{textAlign:'center'}}>
                        <p className='limited'>Limited time deal</p>
                        <div className='dealhead' style={{fontFamily:'times new roman'}}>Pampers pants</div>
                    </Card.Body>
            </Card>
        </div>
        <div >
                <Card className='ms-1'>
                    <Card.Img className=' disccardimg' src={offadul} alt="" />
                    <Card.Body style={{textAlign:'center'}}>
                        <p className='limited'>Limited time deal</p>
                        <div className='dealhead' style={{fontFamily:'times new roman'}}>Adult Diapers</div>
                    </Card.Body>
                </Card>
            </div>
            <div >
                <Card className='ms-1'>
                    <Card.Img className=' disccardimg' src={offdogbed} alt="" />
                    <Card.Body style={{textAlign:'center'}}>

                        <p className='limited'>Limited time deal</p>
                        <div className='dealhead' style={{fontFamily:'times new roman'}}>Dog Beds</div>
                    </Card.Body>
                </Card>
            </div>
        <div>
                <Card className='ms-1'>
                    <Card.Img className=' disccardimg' src={offmosq} alt="" />
                    <Card.Body style={{textAlign:'center'}}>

                        <p className='limited'>Limited time deal</p>
                        <div className='dealhead' style={{fontFamily:'times new roman'}}>Mosquito Bat</div>
                    </Card.Body>
                </Card>
        </div>
        <div>
                <Card className='ms-1'>
                    <Card.Img className=' disccardimg' src={offmam} alt="" />
                    <Card.Body style={{textAlign:'center'}}>

                        <p className='limited'>Limited time deal</p>
                        <div className='dealhead' style={{fontFamily:'times new roman'}}>MamyPoko</div>
                    </Card.Body>
                </Card>
            </div>
            <div>
                <Card className='ms-1'>
                    <Card.Img className='disccardimg' src={offolive} alt="" />
                    <Card.Body style={{textAlign:'center'}}>

                        <p className='limited'>Limited time deal</p>
                        <div className='dealhead' style={{fontFamily:'times new roman'}}>Olive Oil</div>
                    </Card.Body>
                </Card>
            </div>
        </div>

        <h2 className='ms-3 mt-5 mb-2' style={{fontFamily:'times new roman'}}>Offers and Discounts</h2>
        <div className='cards'>
        <div>
                <Card className='ms-1'>
                    <Card.Img  className='disccardimg' src={disc6} alt="" />
                    <Card.Body style={{textAlign:'center'}}>
                    <p className='limited'>10% - 20% Off</p>
                    <div className='dealhead' style={{fontFamily:'times new roman'}}>Insulin Injection</div>               
                    </Card.Body>
                </Card>
            </div>
            <div className='col-lg-2 col-xs-12'>
                <Card className='ms-1'>
                    <Card.Img className='disccardimg' src={disc3} alt="" />
                    <Card.Body style={{textAlign:'center'}}>   
                    <p className='limited'>5% - 10% Off</p>
                    <div className='dealhead' style={{fontFamily:'times new roman'}}>Milk Powders</div>               
                    </Card.Body>
                </Card>
            </div>
            <div className='col-lg-2 col-sm-6'>
                <Card className='ms-1'>
                    <Card.Img className='disccardimg' src={disc5} alt="" />
                    <Card.Body style={{textAlign:'center'}}>   
                    <p className='limited'>10% - 20% Off</p>
                    <div className='dealhead' style={{fontFamily:'times new roman'}}>Pet Accessories</div>               
                    </Card.Body>
                </Card>
            </div>
        <div className='col-lg-2 col-sm-6'>
                <Card className='ms-1'>
                    <Card.Img className='disccardimg' src={disc4} alt="" />
                    <Card.Body style={{textAlign:'center'}}>      
                    <p className='limited'>20% - 30% Off</p>
                    <div className='dealhead' style={{fontFamily:'times new roman'}}>Wheel Chairs</div>            
                    </Card.Body>
                </Card>
            </div>
            <div className='col-lg-2 col-sm-6'>
                <Card className='ms-1'>
                    <Card.Img className='disccardimg ' src={disc2} alt="" />
                    <Card.Body style={{textAlign:'center'}}>         
                    <p className='limited'>5% - 10% Off</p>
                    <div className='dealhead' style={{fontFamily:'times new roman'}}>Beauty Products</div>         
                    </Card.Body>
                </Card>
            </div>
            <div className='col-lg-2 col-sm-6'>
                <Card className='ms-1'>
                    <Card.Img className='disccardimg ' src={disc1} alt="" />
                    <Card.Body style={{textAlign:'center'}}>   
                    <p className='limited'>5% - 15% Off</p>
                    <div className='dealhead' style={{fontFamily:'times new roman'}}>Pet Foods</div>               
                    </Card.Body>
                </Card>
            </div>
        </div>
        <div className='text-center'>
            <p className='meddisc' style={{fontFamily:'Mooli',color:"red",fontWeight:'bold'}}>Discounts on medicines are determined based on the order quantity and the total purchase amount.</p>
        </div>

    </div>
  )
}

export default Dicounts